<template>
<div class="content starting">
    <div class="login boxLogin">
        <b-row>
            <b-col class="box" v-bind:style="{ backgroundImage: 'url(' + background + ')'}">
                <img :src="logo" v-bind:class="position">
            </b-col>
            <b-col>
                <div class="bylogin" v-if="showView ==='login'">
                    <h4>{{ $t("messages.login.signin") }}</h4>
                    <div class="form-group">
                        <b-form-input type="text" v-bind:placeholder="$t('messages.login.placeholder.email')" v-model="email"></b-form-input>
                    </div>
                    <div class="form-group">
                        <b-form-input type="password" v-bind:placeholder="$t('messages.login.placeholder.password')" v-model="password"></b-form-input>
                    </div>
                    <button class="remember" @click="showView ='remember'">{{ $t("messages.login.forgetPassword") }}</button>
                    <button class="enter" v-on:click="signIn" :disabled="isLoading">{{ $t("messages.login.enter") }}</button>

                 
                </div>
                <div v-else-if="showView ==='remember'">
                    <h4>{{ $t("messages.login.passwordRecovery") }}</h4>
                    <div class="form-group">
                        <b-form-input type="text" v-bind:placeholder="$t('messages.login.placeholder.email')" v-model="rememberEmail"></b-form-input>
                    </div>
                    <!-- Cancel -->
                    <button class="remember" @click="showView ='login'">{{ $t("messages.cancel") }}</button>
                    <button v-on:click="rememberPassword" :disabled="rememberEmail.length == 0">{{ $t("messages.login.request") }}</button>
                </div>
              
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown right>
                    <template slot="button-content">
                        <em> {{ currentLanguage }} </em>
                    </template>
                    <b-dropdown-item v-for="(lang, i) in languages" :key="`Lang${i}`" :value="lang.key" @click="$i18n.locale = lang.code">{{ lang.name }}</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
                 <a :href="null" @click="showTerms" target="_blank" class="footer-link">{{ $t("messages.login.legal") }}</a>

                 <p v-model="log"></p>
            </b-col>
        </b-row>
    </div>

    <modal name="terms"
        classes="modal-detail"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        width="55%"
        height="95%"
        :clickToClose="false">
        <div class="modal-detail-content" style="overflow:hidden;height:100%;position:relative;">
            <b-btn @click="$modal.hide('terms');" class="closePopup"> <icon name="times-circle"></icon> </b-btn>
            <div class="sign-up" style="height:100%;">
                <!-- AVISO LEGAL Y CONDICIONES GENERALES DE USO -->
                <h4>{{ $t("messages.legalWarning") }}</h4>
                <terms></terms>
            </div>
            
        </div>
    </modal>
    <modal name="GDPR"
        classes="modal-detail"
        :pivot-y="0.5"
        :adaptive="true"
        :reset="true"
        width="30%"
        height="550"
        :clickToClose="false">
        <div class="modal-detail-content">
            <!-- <b-btn @click="$modal.hide('GDPR');" class="closePopup"> <icon name="times-circle"></icon> </b-btn> -->
            <gdpr v-on:onFinish="onFinish" v-on:onCancel="onCancel" v-on:onResize="onResize"></gdpr>
        </div>
    </modal>
       
    <cookie-law theme="dark-lime" v-bind:buttonText="$t('messages.accept')" >
    <div slot="message">
        <!-- This website uses cookies to ensure you get the best experience on our website <router-link to="legal-notes">Click here</router-link> -->
        {{ $t("messages.cookies") }} <b-btn @click="$modal.show('terms');" class="closePopup"> {{ $t('messages.moreinfo') }}</b-btn>
    </div>
    </cookie-law>
</div>
</template>

<script>

const fb = require('../firebaseConfig.js')
import SignUp from './SignUp.vue'
import gdpr from './GDPR.vue'
import { mapState } from 'vuex'
import CookieLaw from 'vue-cookie-law'
import Terms from './Terms.vue'

export default {
    name: 'login',
    components:{
        SignUp,
        CookieLaw,
        gdpr,
        Terms
    },
    computed: {

        currentLanguage: function () {
            var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
            return this.languages[index].name;
        },
        ...mapState(['languages', 'actionCodeSettings', 'userProfile'])
    },
    data: function () {
        return {
            log:'',
            email: '',
            sendEmail: '',
            password: '',
            rememberEmail: '',
            showView: 'login',
            unwatch: null,
            isLoading: false
        }
    },
    beforeCreate(){
       let host = window.location.host.toLowerCase()
       //let host = 'da-gen.vistapooltest.com'
        // Read query params
      switch(host){
        default:
            this.logo = require('@/assets/logos/logo-bgwhite.png')
            this.background = null
            this.position='middle',
            this.company = 1
      }

    },

    mounted() {
        window.addEventListener('keyup', this.onKeyEnter);
    },

    methods: {
        onKeyEnter(event){
            if (event.keyCode === 13) { 
                this.signIn();
            }
        },
        showTerms() {
             this.$modal.show('terms');  
        },
        signIn: function () {
            this.isLoading = true
            this.$snotify.async(this.$t("messages.login.verifyUser"), () => new Promise((resolve, reject) => {
                fb.auth.signInWithEmailAndPassword(this.email, this.password).then((current) => {
                    this.isLoading = false
                    if(current){
                        window.removeEventListener('keyup', this.onKeyEnter)
                        var unwatch  = this.$watch('userProfile', (profile, oldValue) => {
                            if(profile && profile.id){
                                resolve({
                                    body: this.$t("messages.login.userValid"),
                                    config: {
                                        timeout: 1500,
                                        closeOnClick: true
                                    }
                                })
                                this.checkGDPR()
                            }else{
                            // this.onError('User not valid'); 
                                reject({
                                    body: this.$t("messages.userNotExists"),
                                    config: {
                                        timeout: 2000,
                                        closeOnClick: true
                                    }
                                })
                            }
                        })
                    } 
                }).catch( (err) => {
                    this.isLoading = false
                    let message='';
                    switch(err.code){
                        case 'auth/wrong-password': 
                            message = this.$t("messages.userNotValid")
                        break;
                        default:
                            message = this.$t("messages.userNotExists")
                        break;
                    }
                    reject({
                        body: message,
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                    })
                });
            }))
        },
        checkGDPR: function(){
            if (this.userProfile.GDPR === false) {
                this.$modal.show('GDPR');
            }  else {
                const route = this.$route.query;
                const redirect_uri =route.redirect_uri;
                const state =route.state;
                const code = route.code;
                
                fb.auth.currentUser.getIdToken(true).then( (idToken) => {
                     fb.tokensCollection.add({
                        user: this.userProfile.id,
                        token: idToken,
                        src: 'alexa',
                    }).then(() => {
                        window.location.href = redirect_uri+'#state='+state+'&access_token='+idToken+'&token_type=Bearer'
                    }).catch(err => {
                      this.log= err;
                    })
                })
            }
        },
        onFinish: function(){
            this.$modal.hide('GDPR');
            this.$router.replace('dashboard') 
            this.$store.commit('setUserGDPR')
        },
        onCancel: function(){
            this.$modal.hide('GDPR');
            this.$store.dispatch('clearAll')
            this.signOut()
        },

        rememberPassword: function () {
            fb.auth.sendPasswordResetEmail(this.rememberEmail, this.actionCodeSettings).then( (result) => {
                this.onSuccess(this.$t("messages.login.requestSuccess"));
            }).catch( (err) => {
                this.onError(err.message);
            });
        },
        onSuccess: function (msg) {
            this.$snotify.success(msg, 'Info', {
                timeout: 3000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
            });
        },
        onError: function(msg) {
            console.log('Error. ' + msg)
            this.$snotify.error(msg, 'Error', {
                timeout: 3000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
            });
        },
        showLegal () {
            this.$modal.show('terms');
        },
        onResize() {
            this.modalClass = 'second'
        },

        signOut(){
            fb.auth.signOut().then(() => {
            this.$store.dispatch('clearData')
            this.$router.push('/login')
        }).catch(err => {
            console.log(err)
        })
        }

    }
}
</script>
<style>
.modal-detail {
    border-radius: 5px;
    background: #F7F7F7;
    box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
  }

  .modal-detail-content {
    padding: 10px;
  
  }

</style>


// WEBPACK FOOTER //
// src/components/AlexaLogin.vue